<template>
  <div class="controls">
    <LayoutButtonGroup v-for="itemGroup in controls[getLayout]">
      <FormButton
        v-for="item in itemGroup.group"
        :key="'CONTROL_' + item.name + '.' + getItemKey(item, 'value', false) + searchToken"
        :text="item.text ? item.text : false"
        :value="getItemKey(item, 'value', false)"
        :variant="variant"
        :color="getItemKey(item, 'color', false)"
        :defaultColor="getItemKey(item, 'defaultColor', false)"
        :icon="getItemKey(item, 'icon', false)"
        :iconSize="item.iconSize"
        :iconRotate="item.iconRotate ? item.iconRotate : false"
        :iconReversed="item.iconReversed ? item.iconReversed : false"
        :flipLayout="item.flipLayout ? item.flipLayout : false"
        :selected="getSetting(item.name) === getItemKey(item, 'value', true) ? true : false"
        :disabled="loading || (item.name === 'datasets.download' && (!isAuthenticated || !datasetsLicensed())) || (((item.name === 'dataset.download' && item.value === 'xls') || (item.name === 'dataset.display' && item.value[0] === 'datatable')) && (!isAuthenticated || !datasetsLicensed())) || (getItemKey(item, 'value', false) === 'pie' && pieChartDisabled() === true) || (getItemKey(item, 'value', false) === 'stacked_ver_bar' && stackedBarChartDisabled() === true) ? true : false"
        @clicked="changeControl(item.name, getItemKey(item, 'value', false))"
        :content="((item.name === 'datasets.download') || (item.name === 'dataset.download' && item.value === 'xls')) && (!isAuthenticated || !datasetsLicensed()) ? '<u>Subscribe</u> to download as XLS document!' : getItemKey(item, 'label', false)"
        v-tippy="{ theme: 'statzon', placement: getLayout === 'minimized' ? 'left' : 'top', arrow: true, animation: 'scale' }"
      />
    </LayoutButtonGroup>
  </div>
</template>

<script>
import FormButton from '@/components/form/Button.vue'
import LayoutButtonGroup from '@/components/layout/ButtonGroup.vue'

export default {
  components: {
    FormButton,
    LayoutButtonGroup
  },
  props: {
    controls: {
      type: Object,
      default: function () {
        return {}
      }
    },
    variant: {
      type: String,
      default: 'dark',
      validator (values) {
        return ['dark', 'light'].includes(values)
      }
    },
    layout: {
      type: [Boolean, String],
      default: false,
      validator (values) {
        return [false, 'minimized', 'maximized'].includes(values)
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    results () {
      return this.$store.getters['search/getResults'].dataset
    },
    selectedHash () {
      return this.$store.getters['search/getSelectedHash']
    },
    getLayout () {
      if (this.layout !== false) {
        return this.layout
      } else {
        return ['Datasets', 'PDFs', 'News'].includes(this.$route.name) ? 'maximized' : 'minimized'
      }
    },
    searchToken () {
      return this.$store.getters['search/getSearchToken']
    },
    settings () {
      return this.$store.getters['app/getSettings']
    },
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    }
  },
  methods: {
    changeControl (name, value) {
      this.$emit('controlsChanged', name, value)
    },
    datasetsLicensed () {
      let results = this.$store.getters['search/getResults'].datasets ? this.$store.getters['search/getResults'].datasets : this.$store.getters['search/getResults'].dataset

      if (results) {
        for (const [key, value] of Object.entries(results.byId)) {
          if (value.type === 'datasets' && value.attributes.licensed === true) {
            return true
          }
        }
      }

      return false
    },
    pieChartDisabled () {
      let check = this.results && this.results.byId[this.selectedHash] && this.results.byId[this.selectedHash].attributes.data_series ? Object.keys(this.results.byId[this.selectedHash].attributes.data_series).length : false

      if (check === 1 || check > 50) {
        return true
      }

      return false
    },
    stackedBarChartDisabled () {
      if (this.results && this.results.byId[this.selectedHash]) {
        if (Object.keys(this.results.byId[this.selectedHash].attributes.data_series).length === 1) {
          return true
        }
      }

      return false
    },
    getSetting (name) {
      let parts = name.split('.')
      let mainSetting = parts[0]
      let subSetting = parts[1]

      return this.settings[mainSetting][subSetting]
    },
    getItemKey (item, type, flip) {
      if (Array.isArray(item[type])) {
        let parts = item.name.split('.')
        let mainSetting = parts[0]
        let subSetting = parts[1]
        let settingValue = this.settings[mainSetting][subSetting]

        if (settingValue === item.value[0]) {
          return item[type][flip ? 0 : 1]
        }

        return item[type][flip ? 1 : 0]
      }

      return item[type]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.controls {
  display: flex;
  justify-content: flex-end;
  height: 37px;
  position: relative;
  top: -1px;

  @media screen and (min-width: $breakpointLg) {
    height: 41px;
  }
}

</style>
